import { StyledLink, StyledText } from '@selfserve/react-ui';
import { routesPaths } from '@selfserve/react-utils';
import { useTranslation } from 'react-i18next';

import {
  StyledInfoContainer,
  StyledItemContainer,
} from '../feature/plans-overview';

interface Props {
  nextInvoiceDate: string;
  recurringCharges: string;
}

export const PlanOverviewPaymentInfo = ({
  nextInvoiceDate,
  recurringCharges,
}: Props) => {
  const { t } = useTranslation();
  return (
    <StyledInfoContainer isRow>
      <StyledItemContainer smallRadius>
        <div>
          <StyledText bold>{t('common.next-invoice-date')}</StyledText>
          <StyledText as="span">{nextInvoiceDate}</StyledText>
        </div>
        <StyledLink isSmall to={routesPaths.MANAGEMENT_INVOICE}>
          {t('common.see-invoices')}
        </StyledLink>
      </StyledItemContainer>
      <StyledItemContainer smallRadius>
        <div>
          <StyledText bold>{t('common.recurring-charges')}</StyledText>
          <StyledText as="span">{recurringCharges}</StyledText>
        </div>
      </StyledItemContainer>
    </StyledInfoContainer>
  );
};
